import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import Modal from 'src/components/modal/Modal';
import ApiError from 'src/api/ApiError';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  error?: ApiError;
}

const RejectSalesOrderDraftModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  error,
}) => {
  return (
    <Modal
      open={open}
      title="Are you sure?"
      closeable={false}
      isLoading={isLoading}
      error={error}
      onCloseButton={{
        text: 'Cancel',
        onClick: onClose,
        disabled: isLoading,
      }}
      additionalButtons={[
        {
          text: 'Ignore Purchase Order',
          variant: 'contained',
          color: 'error',
          onClick: onConfirm,
          disabled: isLoading,
        },
      ]}
    >
      <MDBox>
        <MDTypography variant="body2" color="text.secondary">
          This purchase order will be ignored and removed from the active orders
          list. You can still view it by adjusting your filters to include
          ignored and rejected orders.
        </MDTypography>
      </MDBox>
    </Modal>
  );
};

export default RejectSalesOrderDraftModal;
